import React, { useEffect } from 'react';
import './RichText.css';

interface Props {
  titulo: string;
  subtitulo?: string;
  /* Texto chico al pie, junto a lo que se pase en `pie` (p. ej. el botón de IA). */
  nota?: string;
  pie?: React.ReactNode;
  onCerrar: () => void;
  children: React.ReactNode;
}

/* Página completa para escribir largo: la hoja centrada con márgenes de
   documento y la barra de formato fija arriba. No tiene "Guardar" propio:
   el editor de adentro es el mismo que el recuadro chico y comparte su estado,
   así que Esc o "Listo" solo vuelven a la ficha. */
const ModoEscritura: React.FC<Props> = ({ titulo, subtitulo, nota, pie, onCerrar, children }) => {
  useEffect(() => {
    // Esc vuelve a la ficha, salvo que alguien más adentro ya lo usó (el
    // renombrado de una hoja lo cancela con Esc y lo marca como manejado):
    // cancelar un renombrado no puede cerrar la página entera.
    const onKey = (e: KeyboardEvent) => { if (e.key === 'Escape' && !e.defaultPrevented) onCerrar(); };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [onCerrar]);

  return (
    <div className="me" role="dialog" aria-modal="true" aria-label={titulo}>
      <div className="me-barra">
        <div className="me-titulo"><b>{titulo}</b>{subtitulo && <span>{subtitulo}</span>}</div>
        <div className="me-acciones">
          <span className="me-esc">Esc para volver</span>
          <button type="button" className="p-btn-primary" onClick={onCerrar}>Listo</button>
        </div>
      </div>
      <div className="me-lienzo">
        <div className="me-hoja">
          {children}
          {(nota || pie) && (
            <div className="me-pie">
              <span>{nota}</span>
              {pie}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ModoEscritura;
